// extracted by mini-css-extract-plugin
module.exports = {"container":"_2LGPsskDxurmj1Sw1a7xBG","groupsList":"_3SjCtT0GgvSD6gmkEXqqMU"};